import React, { useEffect, useState } from 'react';
import { ArrowDown } from 'lucide-react';

const HeroSection = ({ mode }) => {
  const isUX = mode === 'ux';
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  
  const badge = isUX ? "Available for UX Opportunities" : "Street Photography";
  const title = isUX ? "Designing" : "Capturing";
  const highlight = isUX ? "Human-Centered" : "Urban";
  const subtitle = isUX ? "Experiences" : "Stories";
  const description = isUX 
    ? "MSc HCI graduate transforming research insights into impactful digital products. I bridge the gap between user needs and business goals through evidence-based design."
    : "Through my lens, I document the poetry of everyday life in Newcastle's streets. Each frame tells a story of human connection and urban beauty.";

  // Smooth cursor tracking
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const gradientClass = isUX ? 'gradient-text-blue' : 'gradient-text-orange';

  return (
    <section className="hero-section" data-testid="hero-section">
      {/* Cursor follower */}
      <div 
        className="cursor-glow"
        style={{
          left: mousePos.x,
          top: mousePos.y,
          background: isUX 
            ? 'radial-gradient(circle, rgba(0,113,227,0.08) 0%, transparent 70%)'
            : 'radial-gradient(circle, rgba(255,149,0,0.08) 0%, transparent 70%)'
        }}
      />
      
      <div className="hero-content">
        <div className="hero-avatar-wrapper">
          <div className="hero-avatar" data-testid="hero-avatar">
            <img 
              src="/memoji.png" 
              alt="Aditya Patil"
            />
          </div>
        </div>

        <div className="hero-badge" data-testid="hero-badge">
          <span className="hero-badge-dot"></span>
          {badge}
        </div>

        <h1 className="hero-title" data-testid="hero-title">
          {title}<br />
          <span className={gradientClass}>
            {highlight}
          </span><br />
          {subtitle}
        </h1>

        <p className="hero-description" data-testid="hero-description">
          {description}
        </p>

        <div className="hero-cta">
          <a href="#work" className="btn-primary" data-testid="btn-view-work">
            View My Work
          </a>
          <a href="#contact" className="btn-secondary" data-testid="btn-contact">
            Get In Touch
          </a>
        </div>
      </div>

      <div className="scroll-indicator">
        <ArrowDown size={20} color="var(--text-tertiary)" />
      </div>
    </section>
  );
};

export default HeroSection;
